import { Library, Sprout, Leaf, Vote } from "lucide-react";
import { NavItem } from "./NavItem";
import Link from "next/link";
import { routes } from "@/utils/routes";
import { useMenu } from "@/context/MenuProvider";

interface NavigationProps {
  className?: string;
  isAriaHidden: boolean;
}

export function Navigation({ className, isAriaHidden }: NavigationProps) {
  const { closeMenu } = useMenu();

  return (
    <aside className={"max-md:mt-20 " + className} aria-hidden={isAriaHidden}>
      <nav role="navigation" className="w-full h-full">
        <Link href={routes.discover} onClick={closeMenu}>
          <div className="flex items-center gap-2 pl-8  text-white font-extrabold text-lg">
            <div className="bg-white p-1 rounded-xl">
              <Sprout size={28} className="text-zinc-950" />
            </div>
            <span>GREENLARE</span>
          </div>
        </Link>
        <div className="flex flex-col justify-between mt-8 ">
          <div className="flex flex-col gap-6 mb-6">
            <NavItem onClick={closeMenu} href={routes.discover} title="Discover">
              <Library size={20} />
            </NavItem>
            {/* <NavItem onClick={closeMenu} href={routes.impact} title="Impact">
              <Leaf size={20} />
            </NavItem>
            <NavItem onClick={closeMenu} href={routes.vote} title="Vote">
              <Vote size={20} />
            </NavItem> */}
          </div>
        </div>
      </nav>
    </aside>
  );
}
